<template>
  <section>
    <h3 class="primary--text"><router-link class="no-link-style" style="font-weight:500" :to="{ name: 'Case', params: { case_id: eventDateObj.caseId} }"> {{ eventDateObj.title }}</router-link> {{ message }}</h3>
  </section>
</template>

<script>
export default {
  name: "TitleWithMessage",
  props: ["eventDateObj", "message"]
}
</script>
